module.exports = __webpack_public_path__ + "static/klimaatverandering-hitte-nederland-mobile-85039324abfe85497e262ae88851101a.jpg";